<div class="alert alert-warning" *ngIf="isPreviewMode">Preview mode: interactive functionality is disabled for demonstration purposes.</div>
<nav style="--bs-breadcrumb-divider: url(/assets/Icons/new/angle-right.svg);" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a [routerLink]="'../..'" [queryParams]="{courseId:chapter?.courseId}">Modules</a></li>
    <li class="breadcrumb-item" aria-current="page">{{chapter?.title}} </li>
    <li class="breadcrumb-item active" aria-current="page">Session {{index+1}} </li>
  </ol>
</nav>

<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-lg-8">
        <div class="header d-flex align-items-center justify-content-between mb-4">
          <div>
            <div class="card-title">
              {{session?.title}}
            </div>
            <div class="card-subtitle">
              By {{session?.teacherFullname}}
            </div>
          </div>
          <div class="d-flex align-items-center gap-2">
            <div class="label">Session {{index+1}}/{{chapter?.lessons?.length}}</div>

            <div class="btn-group nav-arrows" role="group" *ngIf="chapter?.lessons?.length>1">
              <a type="button" class="btn pre " [class.btn-primary]="prevLesson" [class.btn-outline]="!prevLesson"
                [routerLink]="prevLesson ? ['..',prevLesson.id]:['..',id]">
                <svg-icon [src]="prevLesson ? '/assets/Icons/new/angle-left-w.svg':'/assets/Icons/new/angle-left.svg'">
                </svg-icon>
              </a>
              <a type="button" class="btn next" [class.btn-primary]="nextLesson" [class.btn-outline]="!nextLesson"
                [routerLink]="nextLesson ? ['..',nextLesson.id]:['..',id]">
                <svg-icon [src]="nextLesson ?'/assets/Icons/new/angle-right-w.svg':'/assets/Icons/new/angle-right.svg'">
                </svg-icon>
              </a>
            </div>
          </div>
        </div>

        <div class="video-container" *ngIf="session?.videoEmbedCode">
          <div [innerHTML]="session?.videoEmbedCode | noSanitize" runScripts></div>
        </div>

        <!-- <div class="video-container" *ngIf="!session?.videoEmbedCode">
          <video controls>
            <source src="movie.mp4" type="video/mp4">
            <source src="movie.ogg" type="video/ogg">
            Your browser does not support the video tag.
          </video>
        </div> -->


        <div class="tab-box">
          <ul ngbNav #nav="ngbNav" class="nav-tabs">
            <li ngbNavItem>
              <button ngbNavLink>Description</button>
              <ng-template ngbNavContent>
                <div class="tab-header d-flex align-items-center gap-2">
                  <svg-icon src="/assets/Icons/new/book-open-text.svg"></svg-icon>
                  Session {{index+1}} Description
                </div>
                <div class="tab-body session-description">
                  <p [innerHTML]="session?.description">
                  </p>
                </div>
              </ng-template>
            </li>


            <li ngbNavItem>
              <button ngbNavLink>Assignments</button>
              <ng-template ngbNavContent>
                <div class="tab-header d-flex align-items-center gap-2">
                  <svg-icon src="/assets/Icons/new/pencil-paper-o.svg"></svg-icon>
                  Assignments
                </div>
                <div class="tab-body">
                  <!-- Startup selection dropdown for Admin users when no startup is preselected -->
                  <div class="mb-4" *ngIf="showStartupDropdown">
                    <!-- Loading indicator -->
                    <div class="alert alert-warning" *ngIf="loadingStartups">
                      <i class="fas fa-spinner fa-spin me-2"></i>
                      Loading startups for this program...
                    </div>

                    <div class="row">
                      <div class="col-md-6 col-lg-4">
                        <label class="form-label">Select Startup to Upload Homework For</label>
                        <p-dropdown 
                          [options]="dataStartups" 
                          placeholder="Select startup to upload homework for..."
                          styleClass="w-100" 
                          optionLabel="startupName" 
                          [filter]="true"
                          [disabled]="loadingStartups"
                          [showClear]="true"
                          (onChange)="onDropdownChange($event)">
                          <ng-template pTemplate="empty">
                            <div class="p-3 text-center">
                              <span *ngIf="loadingStartups">Loading startups...</span>
                              <span *ngIf="!loadingStartups">No startups connected to this program</span>
                            </div>
                          </ng-template>
                        </p-dropdown>
                      </div>
                    </div>
                    
                    <!-- Info message when no startup selected -->
                    <div class="alert alert-info mt-3" *ngIf="!selectedStartupId && !loadingStartups && dataStartups.length">
                      <i class="fas fa-info-circle me-2"></i>
                      <strong>Admin Mode:</strong> Please select a startup above to view and upload homework on their behalf.
                    </div>

                    <!-- Show selected startup -->
                    <div class="alert alert-success mt-3" *ngIf="selectedStartup">
                      <i class="fas fa-check-circle me-2"></i>
                      <strong>Admin Mode:</strong> You are now viewing and can upload homework for <strong>{{selectedStartup.startupName}}</strong>
                    </div>

                    <!-- Show message when no startups available -->
                    <div class="alert alert-warning mt-3" *ngIf="!loadingStartups && !dataStartups.length">
                      <i class="fas fa-exclamation-triangle me-2"></i>
                      No startups are connected to this session yet.
                    </div>
                  </div>

                  <div *ngIf="!assignments?.length">No Assignments</div>
                  <div class="assignments" *ngIf="assignments?.length">
                    <ul class="assignments-list m-0 p-0">
                      <li class="assignment-item" *ngFor="let item of assignments;let i = index;">
                        <div class="assignment-header d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center gap-2">
                            <div class="tag-lg d-flex align-items-center gap-1">
                              <svg-icon src="/assets/Icons/new/pencil paper.svg"></svg-icon>
                              Assignment {{i+1}}
                            </div>
                            <div class="assignment-info">
                              <div class="title">{{item.title}}</div>
                              <ng-container *ngIf="item.dueDate">
                                <div class="sub" *ngIf="!item.locked">Due {{item.dueDate | date:'MMM dd h:mm a'}}</div>
                                <div class="sub" *ngIf="item.locked">Elapsed {{item.dueDate | date:'MMM dd h:mm a'}}
                                </div>
                              </ng-container>
                            </div>
                          </div>

                          <div class="more">
                            <button (click)="downloadAssignmentTemplate(item.id)"
                              *ngIf="item.hasAttachment && !item.locked"
                              class="btn btn-text d-flex align-items-center gap-2">
                              <svg-icon src="/assets/Icons/new//assets/Icons/new/download-green.svg"></svg-icon>
                              Download assignment template files
                            </button>
                          </div>
                        </div>

                        <p [innerHTML]="item.description">
                        </p>

                        <div class="form-info mb-3">
                          <!-- Show admin upload indicator -->
                          <div class="alert alert-primary mb-3" *ngIf="showStartupDropdown && selectedStartup">
                            <i class="fas fa-user-shield me-2"></i>
                            <strong>Admin Upload Mode:</strong> Files uploaded here will be submitted on behalf of <strong>{{selectedStartup.startupName}}</strong>
                          </div>

                          <div class="form-group">
                            <div class="file-upload">
                              <input type="file" [id]="'teaser-'+i" class="d-none" multiple [disabled]="isPreviewMode && (!showStartupDropdown || !selectedStartupId)"
                                (change)="onSelectAttachment($event,i)" formControlName="attachments">
                              <label [for]="'teaser-'+i" class="attachments">
                                <div class="d-flex gap-3">
                                  <div class="attachment-icon flex-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                      fill="none">
                                      <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M10.8026 4.13674C12.5683 2.37109 15.431 2.37109 17.1966 4.13674C18.9623 5.90239 18.9623 8.76508 17.1966 10.5307L11.8633 15.8641C10.834 16.8933 9.16524 16.8933 8.13597 15.8641C7.10669 14.8348 7.10669 13.166 8.13597 12.1367L13.4693 6.80341C13.7622 6.51051 14.2371 6.51051 14.53 6.80341C14.8229 7.0963 14.8229 7.57117 14.53 7.86407L9.19663 13.1974C8.75314 13.6409 8.75314 14.3599 9.19663 14.8034C9.64011 15.2469 10.3591 15.2469 10.8026 14.8034L16.136 9.47007C17.3158 8.29021 17.3158 6.37727 16.136 5.1974C14.9561 4.01753 13.0432 4.01753 11.8633 5.1974L6.52996 10.5307C4.61371 12.447 4.61371 15.5538 6.52996 17.4701C8.44621 19.3863 11.5531 19.3863 13.4693 17.4701L18.8026 12.1367C19.0955 11.8438 19.5704 11.8438 19.8633 12.1367C20.1562 12.4296 20.1562 12.9045 19.8633 13.1974L14.53 18.5307C12.0279 21.0328 7.97133 21.0328 5.4693 18.5307C2.96727 16.0287 2.96726 11.9721 5.4693 9.47008L10.8026 4.13674Z"
                                        fill="white" />
                                    </svg>
                                  </div>
                                  <div>
                                    <div class="title">Upload your homework here</div>
                                    <div class="description">Drag/Drop files here. You can upload a maximum of 5 files,
                                      5MB each.
                                    </div>
                                  </div>
                                </div>
                              </label>
                            </div>

                            <div class="d-flex mt-2 flex-wrap">
                              <button class="btn btn-dl-attachment"
                                *ngFor="let item of myForm?.value?.assignments[i].attachments; let j = index">
                                <div class="file d-flex gap-2">
                                  <i>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                                      fill="none">
                                      <path opacity="0.4"
                                        d="M5 30.0007L5 10.0007C5 6.31875 7.98477 3.33398 11.6667 3.33398L21.6667 3.33398C26.11 7.7773 30.5457 12.2283 35 16.6607C35 21.1073 35 25.554 35 30.0007C35 33.6826 32.0152 36.6673 28.3333 36.6673H11.6667C7.98477 36.6673 5 33.6826 5 30.0007Z"
                                        fill="#2C997F" />
                                      <path
                                        d="M21.667 10.0007L21.667 3.33398L35.0003 16.6673L28.3337 16.6673C24.6518 16.6673 21.667 13.6825 21.667 10.0007Z"
                                        fill="#2C997F" />
                                      <path
                                        d="M9.83691 22.7197H12.4785C13.0742 22.7197 13.5283 22.7653 13.8408 22.8564C14.2607 22.9801 14.6204 23.1999 14.9199 23.5156C15.2194 23.8314 15.4473 24.2188 15.6035 24.6777C15.7598 25.1335 15.8379 25.6966 15.8379 26.3672C15.8379 26.9564 15.7646 27.4642 15.6182 27.8906C15.4391 28.4115 15.1836 28.833 14.8516 29.1553C14.6009 29.3994 14.2624 29.5898 13.8359 29.7266C13.5169 29.8275 13.0905 29.8779 12.5566 29.8779H9.83691V22.7197ZM11.2822 23.9307V28.6719H12.3613C12.765 28.6719 13.0563 28.6491 13.2354 28.6035C13.4697 28.5449 13.6634 28.4456 13.8164 28.3057C13.9727 28.1657 14.0996 27.9362 14.1973 27.6172C14.2949 27.2949 14.3438 26.8571 14.3438 26.3037C14.3438 25.7503 14.2949 25.3255 14.1973 25.0293C14.0996 24.7331 13.9629 24.502 13.7871 24.3359C13.6113 24.1699 13.3883 24.0576 13.1182 23.999C12.9163 23.9535 12.5208 23.9307 11.9316 23.9307H11.2822Z"
                                        fill="#2C997F" />
                                      <path
                                        d="M16.7754 26.3428C16.7754 25.6136 16.8844 25.0016 17.1025 24.5068C17.2653 24.1423 17.4867 23.8151 17.7666 23.5254C18.0498 23.2357 18.359 23.0208 18.6943 22.8809C19.1403 22.6921 19.6546 22.5977 20.2373 22.5977C21.292 22.5977 22.1351 22.9248 22.7666 23.5791C23.4014 24.2334 23.7188 25.1432 23.7188 26.3086C23.7188 27.4642 23.4046 28.3691 22.7764 29.0234C22.1481 29.6745 21.3083 30 20.2568 30C19.1924 30 18.346 29.6761 17.7178 29.0283C17.0895 28.3773 16.7754 27.4821 16.7754 26.3428ZM18.2646 26.2939C18.2646 27.1045 18.4518 27.7197 18.8262 28.1396C19.2005 28.5563 19.6758 28.7646 20.252 28.7646C20.8281 28.7646 21.3001 28.5579 21.668 28.1445C22.0391 27.7279 22.2246 27.1045 22.2246 26.2744C22.2246 25.4541 22.0439 24.8421 21.6826 24.4385C21.3245 24.0348 20.8477 23.833 20.252 23.833C19.6562 23.833 19.1761 24.0381 18.8115 24.4482C18.4469 24.8551 18.2646 25.4704 18.2646 26.2939Z"
                                        fill="#2C997F" />
                                      <path
                                        d="M29.4316 27.2461L30.833 27.6904C30.6182 28.4717 30.2601 29.0527 29.7588 29.4336C29.2607 29.8112 28.6276 30 27.8594 30C26.9089 30 26.1276 29.6761 25.5156 29.0283C24.9036 28.3773 24.5977 27.4886 24.5977 26.3623C24.5977 25.1709 24.9053 24.2464 25.5205 23.5889C26.1357 22.9281 26.9447 22.5977 27.9473 22.5977C28.8229 22.5977 29.5342 22.8564 30.0811 23.374C30.4066 23.68 30.6507 24.1195 30.8135 24.6924L29.3828 25.0342C29.2982 24.6631 29.1208 24.3701 28.8506 24.1553C28.5837 23.9404 28.2581 23.833 27.874 23.833C27.3434 23.833 26.9121 24.0234 26.5801 24.4043C26.2513 24.7852 26.0869 25.402 26.0869 26.2549C26.0869 27.1598 26.2497 27.8044 26.5752 28.1885C26.9007 28.5726 27.3239 28.7646 27.8447 28.7646C28.2288 28.7646 28.5592 28.6426 28.8359 28.3984C29.1126 28.1543 29.3112 27.7702 29.4316 27.2461Z"
                                        fill="#2C997F" />
                                    </svg>
                                  </i>
                                  <div class="file-details me-2">
                                    <div class="file-name">{{item.name}}</div>
                                    <div class="file-size">{{item.size / 1024| number: '1.0-0'}} kb</div>
                                  </div>
                                </div>

                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                  fill="none" (click)="removeAttachment(j,i)" class="ms-2">
                                  <path
                                    d="M21 6.47998C17.67 6.14998 14.32 5.97998 10.98 5.97998C9 5.97998 7.02 6.07998 5.04 6.27998L3 6.47998"
                                    stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path
                                    d="M8.5 5.47L8.72 4.16C8.88 3.21 9 2.5 10.69 2.5H13.31C15 2.5 15.13 3.25 15.28 4.17L15.5 5.47"
                                    stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path
                                    d="M18.85 9.64014L18.2 19.7101C18.09 21.2801 18 22.5001 15.21 22.5001H8.79002C6.00002 22.5001 5.91002 21.2801 5.80002 19.7101L5.15002 9.64014"
                                    stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M10.33 17H13.66" stroke="red" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M9.5 13H14.5" stroke="red" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                </svg>
                              </button>
                            </div>
                            <div class="d-flex mt-2 flex-wrap">
                              <div class="btn btn-dl-attachment"
                                *ngFor="let item of $any(assignments[i].attachments); let j = index">
                                <div class="file d-flex gap-2">
                                  <i>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                                      fill="none">
                                      <path opacity="0.4"
                                        d="M5 30.0007L5 10.0007C5 6.31875 7.98477 3.33398 11.6667 3.33398L21.6667 3.33398C26.11 7.7773 30.5457 12.2283 35 16.6607C35 21.1073 35 25.554 35 30.0007C35 33.6826 32.0152 36.6673 28.3333 36.6673H11.6667C7.98477 36.6673 5 33.6826 5 30.0007Z"
                                        fill="#2C997F" />
                                      <path
                                        d="M21.667 10.0007L21.667 3.33398L35.0003 16.6673L28.3337 16.6673C24.6518 16.6673 21.667 13.6825 21.667 10.0007Z"
                                        fill="#2C997F" />
                                      <path
                                        d="M9.83691 22.7197H12.4785C13.0742 22.7197 13.5283 22.7653 13.8408 22.8564C14.2607 22.9801 14.6204 23.1999 14.9199 23.5156C15.2194 23.8314 15.4473 24.2188 15.6035 24.6777C15.7598 25.1335 15.8379 25.6966 15.8379 26.3672C15.8379 26.9564 15.7646 27.4642 15.6182 27.8906C15.4391 28.4115 15.1836 28.833 14.8516 29.1553C14.6009 29.3994 14.2624 29.5898 13.8359 29.7266C13.5169 29.8275 13.0905 29.8779 12.5566 29.8779H9.83691V22.7197ZM11.2822 23.9307V28.6719H12.3613C12.765 28.6719 13.0563 28.6491 13.2354 28.6035C13.4697 28.5449 13.6634 28.4456 13.8164 28.3057C13.9727 28.1657 14.0996 27.9362 14.1973 27.6172C14.2949 27.2949 14.3438 26.8571 14.3438 26.3037C14.3438 25.7503 14.2949 25.3255 14.1973 25.0293C14.0996 24.7331 13.9629 24.502 13.7871 24.3359C13.6113 24.1699 13.3883 24.0576 13.1182 23.999C12.9163 23.9535 12.5208 23.9307 11.9316 23.9307H11.2822Z"
                                        fill="#2C997F" />
                                      <path
                                        d="M16.7754 26.3428C16.7754 25.6136 16.8844 25.0016 17.1025 24.5068C17.2653 24.1423 17.4867 23.8151 17.7666 23.5254C18.0498 23.2357 18.359 23.0208 18.6943 22.8809C19.1403 22.6921 19.6546 22.5977 20.2373 22.5977C21.292 22.5977 22.1351 22.9248 22.7666 23.5791C23.4014 24.2334 23.7188 25.1432 23.7188 26.3086C23.7188 27.4642 23.4046 28.3691 22.7764 29.0234C22.1481 29.6745 21.3083 30 20.2568 30C19.1924 30 18.346 29.6761 17.7178 29.0283C17.0895 28.3773 16.7754 27.4821 16.7754 26.3428ZM18.2646 26.2939C18.2646 27.1045 18.4518 27.7197 18.8262 28.1396C19.2005 28.5563 19.6758 28.7646 20.252 28.7646C20.8281 28.7646 21.3001 28.5579 21.668 28.1445C22.0391 27.7279 22.2246 27.1045 22.2246 26.2744C22.2246 25.4541 22.0439 24.8421 21.6826 24.4385C21.3245 24.0348 20.8477 23.833 20.252 23.833C19.6562 23.833 19.1761 24.0381 18.8115 24.4482C18.4469 24.8551 18.2646 25.4704 18.2646 26.2939Z"
                                        fill="#2C997F" />
                                      <path
                                        d="M29.4316 27.2461L30.833 27.6904C30.6182 28.4717 30.2601 29.0527 29.7588 29.4336C29.2607 29.8112 28.6276 30 27.8594 30C26.9089 30 26.1276 29.6761 25.5156 29.0283C24.9036 28.3773 24.5977 27.4886 24.5977 26.3623C24.5977 25.1709 24.9053 24.2464 25.5205 23.5889C26.1357 22.9281 26.9447 22.5977 27.9473 22.5977C28.8229 22.5977 29.5342 22.8564 30.0811 23.374C30.4066 23.68 30.6507 24.1195 30.8135 24.6924L29.3828 25.0342C29.2982 24.6631 29.1208 24.3701 28.8506 24.1553C28.5837 23.9404 28.2581 23.833 27.874 23.833C27.3434 23.833 26.9121 24.0234 26.5801 24.4043C26.2513 24.7852 26.0869 25.402 26.0869 26.2549C26.0869 27.1598 26.2497 27.8044 26.5752 28.1885C26.9007 28.5726 27.3239 28.7646 27.8447 28.7646C28.2288 28.7646 28.5592 28.6426 28.8359 28.3984C29.1126 28.1543 29.3112 27.7702 29.4316 27.2461Z"
                                        fill="#2C997F" />
                                    </svg>
                                  </i>
                                  <div class="file-details me-2">
                                    <div class="file-name">{{item.originalFileName}}</div>
                                    <div class="file-size">{{item.sizeInByte / 1024 | number: '1.0-0'}} kb</div>
                                    <!-- Admin submission indicator -->
                                    <div class="admin-indicator text-muted small" *ngIf="item.isSubmittedByAdmin">
                                      <i class="fas fa-user-shield me-1"></i>
                                      Submitted by admin
                                    </div>
                                  </div>
                                </div>

                                <a (click)="download(item)">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                    fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M0.25 15C0.25 17.6234 2.37665 19.75 5 19.75L15 19.75C17.6234 19.75 19.75 17.6234 19.75 15L19.75 11C19.75 8.37665 17.6234 6.25 15 6.25L14.5 6.25C14.0858 6.25 13.75 6.58579 13.75 7C13.75 7.41421 14.0858 7.75 14.5 7.75L15 7.75C16.7949 7.75 18.25 9.20507 18.25 11L18.25 15C18.25 16.7949 16.7949 18.25 15 18.25L5 18.25C3.20507 18.25 1.75 16.7949 1.75 15L1.75 11C1.75 9.20507 3.20507 7.75 5 7.75L5.5 7.75C5.91421 7.75 6.25 7.41421 6.25 7C6.25 6.58579 5.91421 6.25 5.5 6.25L5 6.25C2.37665 6.25 0.25 8.37665 0.25 11L0.25 15ZM6.46967 10.5303C6.17678 10.2374 6.17678 9.76256 6.46967 9.46967C6.76256 9.17678 7.23744 9.17678 7.53033 9.46967L9.25 11.1893L9.25 1C9.25 0.585786 9.58579 0.25 10 0.25C10.4142 0.25 10.75 0.585786 10.75 1L10.75 11.1893L12.4697 9.46967C12.7626 9.17678 13.2374 9.17678 13.5303 9.46967C13.8232 9.76256 13.8232 10.2374 13.5303 10.5303L10.5303 13.5303C10.2374 13.8232 9.76256 13.8232 9.46967 13.5303L6.46967 10.5303Z"
                                      fill="#2C997F" />
                                  </svg>
                                </a>
                                <svg *ngIf="!item.locked" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                  viewBox="0 0 20 20" fill="none" (click)="deleteAttachment(item,j,$event,i)"
                                  class="ms-2">
                                  <path
                                    d="M21 6.47998C17.67 6.14998 14.32 5.97998 10.98 5.97998C9 5.97998 7.02 6.07998 5.04 6.27998L3 6.47998"
                                    stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path
                                    d="M8.5 5.47L8.72 4.16C8.88 3.21 9 2.5 10.69 2.5H13.31C15 2.5 15.13 3.25 15.28 4.17L15.5 5.47"
                                    stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path
                                    d="M18.85 9.64014L18.2 19.7101C18.09 21.2801 18 22.5001 15.21 22.5001H8.79002C6.00002 22.5001 5.91002 21.2801 5.80002 19.7101L5.15002 9.64014"
                                    stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M10.33 17H13.66" stroke="red" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M9.5 13H14.5" stroke="red" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                </svg>
                              </div>
                            </div>
                          </div>

                          <div class="form-group" *ngIf="!isPreviewMode || (isPreviewMode && showStartupDropdown && selectedStartupId)">
                            <button type="submit" class="btn btn-primary" [disabled]="loading" [class.loading]="loading"
                              (click)="onSubmit(i)">
                              <span *ngIf="showStartupDropdown && selectedStartup">Upload for {{selectedStartup.startupName}}</span>
                              <span *ngIf="!showStartupDropdown || !selectedStartup">Submit Homework</span>
                              <span *ngIf="loading" class="loader"></span>
                            </button>
                          </div>
                        </div>
                      </li>

                    </ul>
                  </div>

                </div>
              </ng-template>
            </li>


            <li ngbNavItem>
              <!-- <button ngbNavLink>Similar Links</button>
              <ng-template ngbNavContent>
                <div class="tab-header d-flex align-items-center gap-2">
                  <svg-icon src="/assets/Icons/new/link-horizontal.svg"></svg-icon>
                  Similar Links
                </div>
                <div class="tab-body">
                  <a class="link-item d-flex align-items-center gap-2 mb-3">
                    <svg-icon src="/assets/Icons/new/globe.svg"></svg-icon>
                    <span>www.hdfcbank.com/personal/useful-links</span>
                  </a>
                  <a class="link-item d-flex align-items-center gap-2 mb-3">
                    <svg-icon src="/assets/Icons/new/globe.svg"></svg-icon>
                    <span>www.hdfcbank.com/personal/useful-links</span>
                  </a>
                  <a class="link-item d-flex align-items-center gap-2 mb-3">
                    <svg-icon src="/assets/Icons/new/globe.svg"></svg-icon>
                    <span>www.hdfcbank.com/personal/useful-links</span>
                  </a>
                </div>
              </ng-template> -->
            </li>

            <li ngbNavItem>
              <button ngbNavLink>Attachments</button>
              <ng-template ngbNavContent>
                <div class="tab-header d-flex align-items-center gap-2">
                  <svg-icon src="/assets/Icons/new/pencil-paper-o.svg"></svg-icon>
                  Attachments
                </div>
                <div class="tab-body">
                  <ng-container *ngIf="!session?.attachments?.length">
                    Session has no attachment.
                  </ng-container>
                  <div class="d-flex mt-2 flex-wrap">
                    <div class="btn btn-dl-attachment" *ngFor="let item of session?.attachments; let i = index">
                      <div class="file d-flex gap-2">
                        <img *ngIf="item.contentType?.startsWith('image')" src="/assets/Icons/photo.svg" />
                        <img *ngIf="item.contentType?.startsWith('audio')" src="/assets/Icons/audio.svg" />
                        <img *ngIf="item.contentType?.startsWith('video')" src="/assets/Icons/video.svg" />
                        <img *ngIf="item.contentType?.startsWith('application')" src="/assets/Icons/document.svg" />
                        <div class="file-details me-2">
                          <a download target="_blank" [href]="fileServerUrl + item?.url">
                            <div class="file-name">{{item?.originalFileName}}</div>
                            <div class="file-size">{{item?.sizeInByte | filesize}}</div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </ng-template>
            </li>
          </ul>

          <div [ngbNavOutlet]="nav"></div>

        </div>
      </div>

      <div class="col-lg-4">

        <div class="card card-default mb-4">
          <div class="card-header d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center gap-2">
              <svg-icon class="svg-icon" [src]="'/assets/Icons/new/training.svg'"></svg-icon>
              {{ 'PANEL.LMS.LESSONS.PRESENTER_LABEL' | translate }}
            </div>

            <!-- <button class="btn btn-text d-flex gap-2">
              Biography
              <svg-icon src="/assets/Icons/new/angle-right-green.svg"></svg-icon>
            </button> -->
          </div>
          <div class="card-body d-flex align-items-center justify-content-between">
            <div class="info">
              <div class="title">{{teacher?.fullname}}</div>
              <div class="sub">{{teacherUniversity}}</div>
              <div class="sub sub-sm">{{teacher?.courses?.length}} Programs . {{teacherLearners}} Learners</div>
            </div>
            <div class="img">
              <img [src]="teacher?.profileImageUrl ? teacher.profileImageUrl : defaultAvatar"
                class="avatar avatar-xxxl">
            </div>
          </div>
        </div>

        <div class="box mb-4">
          <div class="box-header">
            <div class="box-title mb-4">{{ 'PANEL.LMS.LESSONS.SESSIONS_OVERVIEW' | translate }}</div>
          </div>

          <div class="box-body mb-5">
            <div class="wizard mb-3">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="label">{{completedCount}}/{{chapter?.lessons?.length}} {{ 'PANEL.LMS.LESSONS.COMPLETED' | translate }}</div>
                <div>
                  <svg-icon src="/assets/Icons/new/award.svg"></svg-icon>
                </div>
              </div>

              <div class="steps d-flex align-items-center gap-1">
                <div class="item" *ngFor="let item of chapter?.lessons;let i = index"
                  [class.completed]="i < completedCount">
                </div>
              </div>
            </div>

            <ul class="wizard-list m-0 p-0 d-flex flex-column gap-3">
              <li class="item d-flex align-items-center justify-content-between gap-1" [class.completed]="item.isViewed"
                [class.actived]="item.id == id" *ngFor="let item of chapter?.lessons;let i = index">
                <div class="d-flex align-items-center gap-2">
                  <div class="list-icon">
                    <svg-icon cla src="/assets/Icons/new/check-circle-24.svg" *ngIf="item.isViewed"></svg-icon>
                    <span class="number" *ngIf="!item.isViewed">{{i + 1}}</span>
                  </div>
                  <div class="title">{{item.title}}</div>
                </div>
                <div class="d-flex align-items-center">
                  <div class="tag tag-light-primary rounded-pill px-2" *ngIf="item.isViewed">Completed</div>
                  <a [routerLink]="['..',item.id]">
                    <svg-icon src="/assets/Icons/new/angle-right.svg" [class.actived]="item.id != id || !item.isViewed">
                    </svg-icon>
                  </a>
                </div>
              </li>

            </ul>

            <!-- <hr> -->

            <!-- <div class="discussion">
              <div class="box-header mb-4">
                <div class="box-title">Discussion</div>
              </div>

              <ul class="comment-list d-flex flex-column m-0 p-0">
                <li class="item d-flex flex-column gap-2">
                  <div class="d-flex align-items-center gap-2">
                    <div class="img">
                      <img [src]="profileImageUrl ? profileImageUrl : defaultAvatar" class="avatar avatar-md">
                    </div>
                    <div class="fullname">Ashley Young</div>
                  </div>

                  <div class="comment">
                    Cool stuf tutor! I’m wondering where i can find this list of recommendations
                  </div>

                  <div class="actions d-flex gap-2 align-items-center">
                    <button class="btn border-0 bg-transparent p-0 d-flex gap-1">
                      <svg-icon src="/assets/Icons/new/arrow-reply.svg"></svg-icon>
                      Reply
                    </button>
                    <span>.</span>
                    <button class="btn border-0 bg-transparent p-0">
                      Show 3 replies
                    </button>
                  </div>
                </li>
                <li class="item">
                  <div class="d-flex flex-column gap-2">
                    <div class="d-flex align-items-center gap-2">
                      <div class="img">
                        <img [src]="profileImageUrl ? profileImageUrl : defaultAvatar" class="avatar avatar-md">
                      </div>
                      <div class="fullname">Ashley Young</div>
                    </div>

                    <div class="comment">
                      Cool stuf tutor! I’m wondering where i can find this list of recommendations
                    </div>

                    <div class="actions d-flex gap-2 align-items-center">
                      <button class="btn border-0 bg-transparent p-0 d-flex gap-1">
                        <svg-icon src="/assets/Icons/new/arrow-reply.svg"></svg-icon>
                        Reply
                      </button>
                      <span>.</span>
                      <button class="btn border-0 bg-transparent p-0">
                        Show 3 replies
                      </button>
                    </div>
                  </div>

                  <ul class="replies-list mt-3">
                    <li class="item">
                      <div class="d-flex flex-column gap-2">
                        <div class="d-flex align-items-center gap-2">
                          <div class="img">
                            <img [src]="profileImageUrl ? profileImageUrl : defaultAvatar" class="avatar avatar-md">
                          </div>
                          <div class="fullname">Ashley Young</div>
                        </div>

                        <div class="comment">
                          Cool stuf tutor! I’m wondering where i can find this list of recommendations
                        </div>

                        <div class="actions d-flex gap-2 align-items-center">
                          <button class="btn border-0 bg-transparent p-0 d-flex gap-1">
                            <svg-icon src="/assets/Icons/new/arrow-reply.svg"></svg-icon>
                            Reply
                          </button>
                          <span>.</span>
                          <button class="btn border-0 bg-transparent p-0">
                            Show 3 replies
                          </button>
                        </div>
                      </div>
                    </li>


                  </ul>
                </li>
              </ul>
            </div> -->

          </div>


          <!-- <div class="box-footer">
            <div class="d-flex align-items-center gap-3">
              <div class="w-100 field-msg ">
                <button class="btn btn-attach p-0 border-0 bg-transparent">
                  <svg-icon src="/assets/Icons/new/attachment.svg"></svg-icon>
                </button>
                <input class="form-control w-100 input-msg" type="text" placeholder="Discuss here..." />
                <button class="btn btn-face p-0 border-0 bg-transparent">
                  <svg-icon src="/assets/Icons/new/face-smile.svg"></svg-icon>
                </button>
              </div>
              <div class="send-msg">
                <button class="btn btn-primary rounded-circle d-flex align-items-center justify-content-center">
                  <svg-icon src="/assets/Icons/new/arrow-up-from-line.svg "></svg-icon>
                </button>
              </div>
            </div>
          </div> -->

        </div>


        <!-- <div class="box mb-4">
          <div class="box-body d-flex align-items-center justify-content-between">
            <div>
              <button class="btn btn-share border-0 bg-transparent p-0">
                <svg-icon class="svg-icon" [src]="'/assets/Icons/new/share.svg'"></svg-icon>
                Share
              </button>
              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                  fill="#4B5563" />
                <path
                  d="M8.99999 21.75H7.99999C7.58999 21.75 7.24999 21.41 7.24999 21C7.24999 20.59 7.56999 20.26 7.97999 20.25C6.40999 14.89 6.40999 9.11 7.97999 3.75C7.56999 3.74 7.24999 3.41 7.24999 3C7.24999 2.59 7.58999 2.25 7.99999 2.25H8.99999C9.23999 2.25 9.46999 2.37 9.60999 2.56C9.74999 2.76 9.78999 3.01 9.70999 3.24C7.82999 8.89 7.82999 15.11 9.70999 20.77C9.78999 21 9.74999 21.25 9.60999 21.45C9.46999 21.63 9.23999 21.75 8.99999 21.75Z"
                  fill="#4B5563" />
                <path
                  d="M14.9999 21.7501C14.9199 21.7501 14.8399 21.7401 14.7599 21.7101C14.3699 21.5801 14.1499 21.1501 14.2899 20.7601C16.1699 15.1101 16.1699 8.89006 14.2899 3.23006C14.1599 2.84006 14.3699 2.41006 14.7599 2.28006C15.1599 2.15006 15.5799 2.36006 15.7099 2.75006C17.6999 8.71006 17.6999 15.2701 15.7099 21.2201C15.6099 21.5501 15.3099 21.7501 14.9999 21.7501Z"
                  fill="#4B5563" />
                <path
                  d="M12 17.2C9.21 17.2 6.43 16.81 3.75 16.02C3.74 16.42 3.41 16.75 3 16.75C2.59 16.75 2.25 16.41 2.25 16V15C2.25 14.76 2.37 14.53 2.56 14.39C2.76 14.25 3.01 14.21 3.24 14.29C8.89 16.17 15.12 16.17 20.77 14.29C21 14.21 21.25 14.25 21.45 14.39C21.65 14.53 21.76 14.76 21.76 15V16C21.76 16.41 21.42 16.75 21.01 16.75C20.6 16.75 20.27 16.43 20.26 16.02C17.57 16.81 14.79 17.2 12 17.2Z"
                  fill="#4B5563" />
                <path
                  d="M21 9.74999C20.92 9.74999 20.84 9.73999 20.76 9.70999C15.11 7.82999 8.88003 7.82999 3.23003 9.70999C2.83003 9.83999 2.41003 9.62999 2.28003 9.23999C2.16003 8.83999 2.37003 8.41999 2.76003 8.28999C8.72003 6.29999 15.28 6.29999 21.23 8.28999C21.62 8.41999 21.84 8.84999 21.7 9.23999C21.61 9.54999 21.31 9.74999 21 9.74999Z"
                  fill="#4B5563" />
              </svg>
            </div>
            <div class="d-flex align-items-center gap-4">
              <a href="#">
                <svg-icon class="svg-icon" [src]="'/assets/Icons/new/icon-fb.svg'"></svg-icon>
              </a>
              <a href="#">
                <svg-icon class="svg-icon" [src]="'/assets/Icons/new/icon-insta.svg'"></svg-icon>
              </a>
              <a href="#">
                <svg-icon class="svg-icon" [src]="'/assets/Icons/new/icon-linkedin.svg'"></svg-icon>
              </a>
              <a href="#">
                <svg-icon class="svg-icon" [src]="'/assets/Icons/new/icon-tw.svg'"></svg-icon>
              </a>
            </div>
          </div>
        </div> -->


      </div>
    </div>
  </div>
</div>
<p-confirmDialog></p-confirmDialog>